import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Modal = _resolveComponent("Modal")!

  return (_ctx.modelValue)
    ? (_openBlock(), _createBlock(_component_Modal, {
        key: 0,
        title: _ctx.$t('pusatResolusi.success.title', { noIssue: _ctx.noIssue }),
        message: _ctx.$t('pusatResolusi.success.message'),
        image: "ill_badge_success",
        textSuccess: _ctx.$t('pusatResolusi.success.ok'),
        class: "px-8",
        customWidth: "400px",
        onSubmit: _ctx.onSubmitModal,
        customButton: "w-full",
        customParentButton: "w-full",
        customWrapperButton: "w-full px-6",
        imageWidth: 36,
        imageHeight: 36
      }, null, 8, ["title", "message", "textSuccess", "onSubmit"]))
    : _createCommentVNode("", true)
}